import { useSelector } from "react-redux";

import { RootState } from "../../../store";
import { IProductInfo } from "../../home/types/Menu";
import { isCartLimitReached } from "../libs/cartLimit";

/**
 * Достигнут ли лимит max_cart_qty — чтобы приглушить «+». Кнопку не
 * выключаем: нажатие показывает тост с лимитом (useAddToBasket), иначе
 * непонятно, почему «+» не срабатывает.
 */
export const useCartLimitReached = (
  product?: Pick<IProductInfo, "id" | "max_cart_qty"> | null,
) =>
  useSelector((state: RootState) =>
    product ? isCartLimitReached(state.basket.items, product) : false,
  );
